import { FunctionComponent } from 'react';

const Chatbot: FunctionComponent<{
  isWebchatOpen: boolean;
  toggleIsWebchatOpen: () => void;
  botpressClientId: string;
}> = () => {
  return null;
};

export default Chatbot;
